/**
 * Created by renjie.huang on 2017/10/11.
 */
import {
  Box,
  Button,
  Form,
  Icon,
  Input,
  Select as NewSelect,
  Tabs,
} from "@ucloud-fe/react-components";
import _ from "_";
import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { browserHistory } from "react-router";
import s from "underscore.string";
import validator from "validator";
import cookie from "../../common/cookie.js";
import uuid from "../../common/uuid.js";
import config from "../../config/config.js";
import { isMobile } from "../../service/deviceDetectService.js";
import localeService from "../../service/localeService.js";
import dasService from "../../service/dasService.js";
import registerService from "../../service/registerService.js";
import CodeModal from "./CodeModal.jsx";
import Notice from "./Notice.jsx";
import Password from "./Password.js";
import NewPassword from "./NewPassword.js";
import TcCheckBox from "./TcCheckBox.jsx";
import OAuthBtn from "./ThirdPartyOAuth/OAuthBtn.jsx";
import OAuthGithub from "./ThirdPartyOAuth/OAuthGithub.jsx";
import PhoneInput from "./PhoneInput.jsx";

import "@ucloud/ucloud-icons/dist/uc-user/css/icon_division.min.css";
import action from "../../common/action.js";
import request from "../../common/request.js";
import userSerivce from "../../service/userService.js";
import userInfoService from "../../service/userInfoService.js";
import {
  AccoutLoginContainer,
  CompusTipContainer,
  CompusTipMobileContainer,
  LoginButtonContainer,
  SocialRegisterTitle,
  RegisterTabWrapper,
} from "./style.jsx";
// const AllowDomain = ['passport.ucloud.cn', 'passport-test03.ucloudadmin.com']
import lang from "../../common/lang.js";
import setTitle from "../../common/setTitle.js";
import { getGeetestLanguage, handleSearch } from "../../common/utils.js";

const REGISTER_TYPE_EMAIL = "email";
const REGISTER_TYPE_PHONE = "phone";
const ACTIVE_LOGIN_MODE_PHONE = "Phone";

const REGISTER_TYPES_MAP = {
  [REGISTER_TYPE_EMAIL]: "REGISTER_EMAIL",
  [REGISTER_TYPE_PHONE]: "REGISTER_PHONE",
}

let REGISTER_TYPES = APP_CONFIG.registerTypes ? APP_CONFIG.registerTypes.split(',') : [REGISTER_TYPE_EMAIL, REGISTER_TYPE_PHONE];

if (APP_CONFIG.isHidePhoneLogic) {
  REGISTER_TYPES = REGISTER_TYPES.filter(e => e !== REGISTER_TYPE_PHONE);
}

if (!APP_CONFIG.isShowPhoneLogin) {
  REGISTER_TYPES = REGISTER_TYPES.filter(e => e !== REGISTER_TYPE_PHONE);
}

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    let self = this;

    // 如果url上带了fastOauthType=Github或Google，则直接触发快捷登录注册
    const query = new URLSearchParams(location.search);
    const OauthType = query.get('fastOauthType');
    self.OauthType = OauthType;

    self.verifySid = uuid();
    self.query = self.props.location.query;
    if (self.query["invitation_code"]) {
      cookie.setCookie("invitation_code", self.query["invitation_code"]);
    }
    self.invitationCode = self.query["invitation_code"]
      ? self.query["invitation_code"]
      : cookie.getCookie("invitation_code");

    if (self.query["referral_code"]) {
      cookie.setCookie("referral_code", self.query["referral_code"]);
    }
    self.referralCode = self.query["referral_code"]
      ? self.query["referral_code"]
      : cookie.getCookie("referral_code");

    self.referrerUrl = cookie.getCookie("ytag") ? cookie.getCookie("ytag") : "";
    self.referrerCode = cookie.getCookie("bd_vid") ? cookie.getCookie("bd_vid") : "";

    if (self.query["ytag"]) {
      self.referrerUrl = self.query["ytag"];
    }
    if (self.query["bd_vid"]) {
      self.referrerCode = self.query["bd_vid"];
    }

    const cpsCodeFromQuery = self.query["cps_code"];
    const cpsCodeFromCookie = cookie.getCookie("cps_code");
    if (cpsCodeFromQuery) {
        self.cpsCode = cpsCodeFromQuery.slice(0, 100);
        // 设置 cps_code 到 cookie， 过期时间为 1 天
        cookie.setCookie("cps_code", self.cpsCode, false, 1);
    } else if(cpsCodeFromCookie){
        self.cpsCode = cpsCodeFromCookie;
    }

    if (APP_CONFIG.isEnableImpact) {
      const imRefFromQuery = self.query["IM_REF"];
      const imRefFromCookie = cookie.getCookie("im_ref");
      if (imRefFromQuery) {
          self.imRef = imRefFromQuery.slice(0, 200);
          // 设置 im_ref 到 cookie， 过期时间为 1 天
          cookie.setCookie("im_ref", self.imRef, false, 120);
      } else if(imRefFromCookie){
          self.imRef = imRefFromCookie;
      }
    }

    self.ActivityCode = cookie.getCookie("ActivityCode")
      ? cookie.getCookie("ActivityCode")
      : "";

    if (self.query["ActivityCode"]) {
      self.ActivityCode = self.query["ActivityCode"];
    }
    self.countryListCloseHandler = self.countryListClose.bind(self);
    this.handleSendCode = () => { };
    self.state = {
      tcChecked: false,
      notSingaporeChecked: false,
      countryList: [],
      userEmail: self.query["user_name"] ? self.query["user_name"] : "",
      phoneNumber: "",
      SendType: "SMS",
      country: "",

      phoneTabPhoneNumber: "",
      phoneTabCountry: "86",
      phoneTabPhoneCode: "",
      isShowSelectAccount: false, // 手机号登录，选择账号
      phoneUsers: [], // 手机号绑定的账号(账号已开通手机号登录功能)
      registerType: REGISTER_TYPES[0],

      phoneCountSecond: 0,
      smsCountSecond: 0,
      errorMsg: "",
      password: "",
      PhoneCode: "",
      phoneInterval: 0,
      smsInterval: 0,
      passwordStrength: -1,
      showCodeInput: false,
      currentCountryList: [],
      isCountryOpen: false,
      showCodeModal: false,
      showPicureCodeInput: true,
      lang: lang.getLang("_lang"),
      iscompusEmail: false,
      // 标记 是否开启无手机号注册的情况
      isShowRegisterVerify: false,
      error: false
    };

    // ucan 活动页提交信息后，注册页支持自动填充邮箱和手机号，填充完后自动删除cookie信息
    // ucan_form_code='手机号,邮箱'
    try {
      var ucanData = decodeURIComponent(
        cookie.getCookie("ucan_form_code") || ""
      );
      if (ucanData && !self.query["user_name"]) {
        self.state.userEmail = ucanData.split(",")[1];
        self.state.phoneNumber = ucanData.split(",")[0];
        cookie.setCookie("ucan_form_code", "");
      }
    } catch (e) {
      console.error("ucan_form_code error", e);
    }

    registerService
      .fetchCountryList()
      .then(function (data) {
        self.countryList = data;
        self.setCountryState();
      })
      .catch(function (data) { });
  }
  //极验初始化
  initVerify() {
    let self = this;
    request(action.register.RegisterGeekVerification, {
      ClientType: "web",
      // 2024-11-6吗，目前就2种情况，无手机号传CreateAccount，剩余都传SendRegisterPhoneCode
      Applicant: APP_CONFIG.isHidePhoneLogic ? "CreateAccount" : "SendRegisterPhoneCode",
      GeeTestVersion: "4.0",
    })
      .success((res) => {
        let succ = res && res.GeetestId;
        if (succ && res.Model === "geektest") {
          return window.initGeetest4(
            {
              captchaId: res.GeetestId,
              product: "bind",
              protocol: "https://",
              language: getGeetestLanguage(),
            },
            function (captchaObj) {
              captchaObj
                .onReady(function () { })
                .onSuccess(function () {
                  const res = captchaObj.getValidate();
                  const result = {
                    GeeTestVersion: "4.0",
                    CaptchaId: res.captcha_id,
                    CaptchaOutput: res.captcha_output,
                    GenTime: res.gen_time,
                    LotNumber: res.lot_number,
                    PassToken: res.pass_token,
                  };
                  // 三方授权注册
                  if (!self.isShowRegisterVerify) {
                    if (self.RegisterByOAuth) {
                      self.confirmOAuthBind(self.RegisterByOAuth, result);
                    } else {
                      self.sendRegisterPhoneCode(result);
                    }
                  }
                  // 无手机号的情况下，注册前极验
                  if (self.isShowRegisterVerify && APP_CONFIG.isHidePhoneLogic) {
                    self.isShowRegisterVerify = true;
                    self.register(result);
                  }
                })
                .onError(function () { });
              self.bindVerify = (e) => {
                e && e.stopPropagation();
                return captchaObj.showCaptcha();
              };
              // 对url和config同时进行校验
              if ((APP_CONFIG.isOAuthByGithub && self.OauthType === 'GitHub') || (APP_CONFIG.isOAuthByGoogle && self.OauthType === 'Google')) {
                self.RegisterByOAuth = self.OauthType;
                self.bindVerify && self.bindVerify();
              }
              // 按钮提交事件
              self.handleSendCode = function (e) {
                // 点击函数
                // 检测验证码是否ready, 验证码的onReady是否执行
                e && e.stopPropagation();
                if (
                  !self.state.userEmail ||
                  !validator.isEmail(self.state.userEmail)
                ) {
                  return self.setState({
                    errorMsg: localeService.getTranslate("LOGIN42"),
                  });
                } else if (!validator.isNumeric(self.state.phoneNumber)) {
                  return self.setState({
                    errorMsg: localeService.getTranslate("INVALID_MOBILE"),
                  });
                } else if (self.state.phoneCountSecond !== 0) {
                  return false;
                }
                return self.setState({ errorMsg: "" }, () =>
                  captchaObj.showCaptcha()
                );
              };
            }
          );
        } else if (res && res.Model === "picture") {
          self.handleSendCode = function (e) {
            e && e.stopPropagation();
            if (self.state.phoneCountSecond !== 0) {
              return false;
            }
            return self.clickShowCodeModal();
          };
        }
      })
      .fail((err) => {
        self.setState({ errorMsg: localeService.getTranslate("LOGIN57") });
      });
  }
  // 发送注册验证码 极验
  sendRegisterPhoneCode(result) {
    let self = this;
    const data = _.extend(
      {},
      {
        UserPhone: `(${self.state.country})${self.state.phoneNumber}`,
        SendType: self.state.SendType,
        ...result,
      }
    );
    registerService
      .sendRegisterCode(data)
      .then(function (data) {
        self.setSendTime();
      })
      .catch(function (data) {
        if (data["RetCode"] == "11097" || data["RetCode"] == "11098") {
          self.setState({
            PictureCode: "",
            errorMsg: "",
            pictureCodeErrorMsg: data['I18N-Message'] || localeService.getTranslate(data["RetCode"]),
          });
          return;
        }
        self.setState({
          pictureCodeErrorMsg: "",
          errorMsg: data['I18N-Message'] || localeService.getTranslate(
            data["RetCode"] || data["Retcode"]
          ),
        });
      });
  }

  // 授权第三方注册，生成 OAuth URL
  confirmOAuthBind = (providerType, GtConfig) => {
    const params = {
      Provider: providerType,
      Type: "Login",
      ...GtConfig,
    };
    request(action.oauth.CreateOAuthURL, params)
      .success(function (data) {
        window.location.href = data["OAuth"]["AuthURL"];
      })
      .fail(function (error) {
        this.setState({ errorMsg: error['I18N-Message'] || error.Message });
      });
  };

  componentDidMount() {
    var self = this;
    if (self.state.userEmail) {
      var emailDOM = ReactDOM.findDOMNode(self.emailInput);
      var inputDOM = emailDOM.getElementsByTagName("input");
      inputDOM.length && (inputDOM = inputDOM[0]);
      inputDOM.focus();
    }
    self.initVerify();
  }

  setCountryState(type) {
    var self = this;
    var _countryList = self.countryList;
    var _currentCountryList;
    var _country;
    var _type = type || self.state.SendType;
    if (_type == "SMS") {
      _currentCountryList = _.filter(_countryList, function (item) {
        return item;
      });
    } else {
      //语音验证码模式只支持国内
      _currentCountryList = _.filter(_countryList, function (item) {
        return item.PhonePrefix == "86";
      });
    }
    if (APP_CONFIG.CountryCode) {
      _country = _currentCountryList.find(
        (e) => e.CountryCode == APP_CONFIG.CountryCode
      );
    } else {
      _country = _currentCountryList[0];
    }
    self.setState({
      currentCountryList: _currentCountryList,
      country: _country.PhonePrefix,
    });
  }

  register(geekParam) {
    var self = this;
    var _activeUrl = registerService.getActiveUrl();

    var data = {
      UserPhone: APP_CONFIG.isHidePhoneLogic
        ? ""
        : `(${self.state.country})${self.state.phoneNumber}`,
      UserEmail: self.state.userEmail,
      UserPwd: self.state.password,
      ActiveUrl: _activeUrl,
      Version: "2.0",
      PhoneCode: self.state.PhoneCode,
      CompanyProperty: {},
    };

    if (self.referralCode) {
      data.ReferralCode = self.referralCode;
    }

    if (self.invitationCode) {
      data.InvitationCode = self.invitationCode;
    }

    if (self.referrerUrl) {
      data.ReferrerUrl = self.referrerUrl;
    }
    if (self.referrerCode) {
      data.ReferrerCode = self.referrerCode;
    }
    if (self.ActivityCode) {
      data.ActivityCode = self.ActivityCode;
    }
    if (self.cpsCode) {
      data.ReferralCode = self.cpsCode;
    }

    if (self.imRef) {
      data.CompanyProperty.ImpactReferralCode = self.imRef;
    }

    // 没有手机号的情况下，注册,前需要加入极验的参数
    if (APP_CONFIG.isHidePhoneLogic) {
      data = { ...data, ...geekParam };
    }
    registerService
      .register(data)
      .then(function (data) {
        self.clearAllInterval();
        if (self.invitationCode) {
          cookie.setCookie("invitationCode", "", true);
        }
        browserHistory.push(
          "/active?email=" +
          encodeURIComponent(self.state.userEmail) +
          "&validType=register"
        );
      })
      .catch(function (data) {
        //注册失败
        self.setState({
          errorMsg: data['I18N-Message'] || localeService.getTranslate(data["RetCode"]),
          pictureCodeErrorMsg: "",
        });
      });
  }

  reSendEmail(email = "") {
    browserHistory.push(
      "/active?email=" + encodeURIComponent(email) + "&validType=resend"
    );
  }

  goToServiceUrl() {
    window.open(config.default, "_self");
  }

  afterLoginSuccess() {
    userSerivce
      .getUserInfo()
      .then(() => {
        window.open(config.default, "_self");
      })
      .catch(() => {
        window.open(config.default, "_self");
      });
  }

  // 和登录页的逻辑是一样的，后期需要统一抽离下，登录页里的手机登录还有APP二维码的逻辑有些耦合
  loginByPhoneSms = (userInfo) => {
    const { phoneTabPhoneNumber, phoneTabCountry, phoneTabPhoneCode } = this.state;
    const Code = phoneTabPhoneCode || "";
    const UserPhone = `(${phoneTabCountry})${phoneTabPhoneNumber}`;

    const UserID = (userInfo && userInfo["UserID"]) || "";
    const UserName = (userInfo && userInfo["UserName"]) || "";

    let params = { UserPhone, Code };

    if (this.referralCode) {
      params.ReferralCode = this.referralCode;
    }
    if (this.invitationCode) {
      params.InvitationCode = this.invitationCode;
    }
    if (this.referrerUrl) {
      params.ReferrerUrl = this.referrerUrl
    }
    if (this.referrerCode) {
      params.ReferrerCode = this.referrerCode
    }
    if (this.cpsCode) {
      params.ReferralCode = this.cpsCode;
    }
    if (UserID) {
      params = { ...params, UserID };
    }

    request(action.login.LoginBySms, params)
      .success(() => {
        this.afterLoginSuccess();
      })
      .fail((data) => {
        const _RetCode = data["RetCode"];
        // 手机号绑定多个账号，选择账号登录
        if (_RetCode === 11331) {
          const Users = data["Data"]["Users"] || [];
          this.setState({
            isShowSelectAccount: true,
            phoneUsers: Users,
            errorMsg: "",
          });
        } else if (_RetCode === 11945) {
          // 已开启TOTP验证，需要跳转TOTP验证页面
          userInfoService.getInstance().userInfo = { UserPhone, Code, UserID };
          const url = `/OAuth/?service=${config.default}&loginType=${ACTIVE_LOGIN_MODE_PHONE}#google`;
          browserHistory.push(url);
        } else if (_RetCode === 11133) {
          // 主账号给子账号强制开启登录保护且子账号未绑定TOTP，需要跳转TOTP绑定和验证页面
          userInfoService.getInstance().userInfo = {
            UserPhone,
            Code,
            UserID,
            topInfo: data.TOTPInfo,
          };
          const url = `/subaccountauth?loginType=${ACTIVE_LOGIN_MODE_PHONE}`;
          browserHistory.push(url);
        } else if (_RetCode === 11072) {
          // 账户未激活，手机号选择账号登录时很低概率会出现账号未激活的情况
          if (UserName) {
            this.reSendEmail(UserName);
          } else {
            this.setState({
              errorMsg: data['I18N-Message'] || localeService.getTranslate(data.RetCode),
            });
          }
        } else if (_RetCode === 294) {
          // 访问IP被拒绝
          let text = data["Data"]["ClientIP"] || "";
          let texts = text ? (
            <span>
              {data['I18N-Message'] || localeService.getTranslate(_RetCode)}
              <br />
              {localeService.getTranslate("LOGIN61")}
              {text}
            </span>
          ) : (
            data['I18N-Message'] || localeService.getTranslate(_RetCode)
          );
          this.setState({ errorMsg: texts });
        } else {
          let errorMsg = data['I18N-Message'] || localeService.getTranslate(data.RetCode);
          if (errorMsg == " ") {
            errorMsg = localeService.getTranslate(-1);
          }
          this.setState({ errorMsg });
        }
      });
  };

  registerPreHandle() {
    const { registerType, phoneTabPhoneNumber, phoneTabPhoneCode, userEmail } = this.state;
    if (registerType === REGISTER_TYPE_EMAIL) {
      dasService.report("REGISTER_EMAIL_REG_CLICK", userEmail);
      // skipCaptchaWhenRegister 注册时跳过验证码
      if (APP_CONFIG.skipCaptchaWhenRegister) {
        this.register({});
        return;
      }

      // 没有手机号的情况下，注册之前需要进行 极验
      if (APP_CONFIG.isHidePhoneLogic) {
        this.isShowRegisterVerify = true;
        this.bindVerify && this.bindVerify();
        dasService.report("REGISTER_EMAIL_REG_VERIFY", userEmail);
        return;
      }

      this.register({});
    } else if (registerType === REGISTER_TYPE_PHONE) {
      // 手机号登录
      if (!phoneTabPhoneNumber) {
        this.setState({ errorMsg: localeService.getTranslate("REGISTER01") });
        return;
      }

      dasService.report("REGISTER_PHONE_REG_CLICK", phoneTabPhoneNumber);
      if (!validator.isNumeric(phoneTabPhoneNumber)) {
        this.setState({
          errorMsg: localeService.getTranslate("INVALID_MOBILE"),
        });
        return;
      }
      if (!phoneTabPhoneCode) {
        this.setState({ errorMsg: localeService.getTranslate("LOGIN8") });
        return;
      }

      this.loginByPhoneSms()
    }
  }

  setSendTime() {
    var self = this;
    self.setState({
      phoneCountSecond: 60,
    });
    self.phoneInterval = setInterval(function () {
      let _remain = self.state.phoneCountSecond - 1;
      self.setState({
        phoneCountSecond: _remain,
      });
      if (_remain <= 0) {
        clearInterval(self.phoneInterval);
        self.phoneInterval = 0;
        return;
      }
    }, 1000);
  }

  clearAllInterval() {
    var self = this;
    if (self.phoneInterval) {
      clearInterval(self.phoneInterval);
    }

    if (self.smsInterval) {
      clearInterval(self.smsInterval);
    }
  }

  sendVerifyCode() {
    var self = this;
    if (!this.state.country) {
      this.setState({
        errorMsg: localeService.getTranslate("NO_COUNTRY"),
        pictureCodeErrorMsg: "",
      });
      return;
    } else if (!validator.isNumeric(this.state.phoneNumber)) {
      this.setState({
        errorMsg: localeService.getTranslate("INVALID_MOBILE"),
        pictureCodeErrorMsg: "",
      });
      return;
    }

    var data = {
      UserPhone: `(${this.state.country})${this.state.phoneNumber}`,
      SendType: this.state.SendType,
    };

    if (this.state.showPicureCodeInput && !this.state.PictureCode) {
      this.setState({
        pictureCodeErrorMsg: localeService.getTranslate("RETRIEVE18"),
      });
      return;
    }

    if (this.state.PictureCode) {
      data.SID = this.verifySid;
      data.PictureCode = this.state.PictureCode;
    }
    registerService
      .sendRegisterCode(data)
      .then(function (data) {
        self.setSendTime();
        self.setState({
          errorMsg: "",
          showCodeModal: false,
          pictureCodeErrorMsg: "",
        });
      })
      .catch(function (data) {
        self.verifySid = uuid();
        if (data["RetCode"] == "11097" || data["RetCode"] == "11098") {
          self.setState({
            PictureCode: "",
            errorMsg: "",
            pictureCodeErrorMsg: data['I18N-Message'] || localeService.getTranslate(data["RetCode"]),
          });
          return;
        }
        self.setState({
          // showPicureCodeInput: false,
          pictureCodeErrorMsg: data['I18N-Message'] || localeService.getTranslate(
            data["RetCode"] || data["Retcode"]
          ),
          // showCodeModal:false,
          errorMsg: data['I18N-Message'] || localeService.getTranslate(
            data["RetCode"] || data["Retcode"]
          ),
        });
      });
  }

  changePhoneNumber(event) {
    this.setState({
      phoneNumber: event.target.value,
    });
  }

  selectCountry(val) {
    var self = this;
    self.setState({
      country: val,
    });
    self.countryListCloseHandler();
  }

  buildCodeContent() {
    var self = this;
    var _icon =
      self.state.SendType == "SMS" ? "icon__message" : "icon__telephone";
    var _className = `u-dib u-vt ${_icon} u-ml15 code-icon`;
    var _sentLocale =
      self.state.SendType == "SMS"
        ? localeService.getTranslate("LOGIN12")
        : localeService.getTranslate("LOGIN45");
    /**
     * 选择语音发送并且无倒计时情况
     */
    if (self.state.phoneCountSecond == 0) {
      return (
        <div
          className="send-code-btn u-blue"
          onClick={() => this.handleSendCode()}
        >
          <span className={_className} />
          <span className="u-dib u-vt desc">
            {localeService.getTranslate("LOGIN11")}
          </span>
        </div>
      );
    } else if (self.state.phoneCountSecond > 0) {
      return (
        <Box container justifyContent="center" alignItems="center">
          <span className={`${_icon} u-ml8 code-icon`} />
          <span className="u-dib u-vt desc">
            {_sentLocale}({self.state.phoneCountSecond}s)
          </span>
        </Box>
      );
    }
  }

  switchSendType() {
    var self = this;
    var _copy = self.getSwitchDisabledCopy();
    if (_copy) {
      return;
    }
    var _type = this.state.SendType == "PHONE" ? "SMS" : "PHONE";
    self.setCountryState(_type);
    self.setState({
      SendType: _type,
    });
  }

  passwordChange(val) {
    var self = this;
    // var _strength = strength(val || self.state.password);
    // var _copy = self.getStrengthCopy(_strength);
    self.setState({
      password: val,
      // strengthText : _copy,
      // passwordStrength : _strength
    });
  }

  userEmailChange(event) {
    var self = this;
    var value = event.target.value ? event.target.value : "";
    value = s(value).trim().value();

    self.setState({
      userEmail: value,
    });

    const pattern = /(.edu.cn|.edu.tw|.edu.hk|.edu.sg)$/;
    if (
      validator.isEmail(value) &&
      pattern.test(value) &&
      !APP_CONFIG.isHideCampusRegister
    ) {
      const emailDOM = ReactDOM.findDOMNode(self.emailInput);
      let inputDOM = emailDOM.getElementsByTagName("input");
      self.setState({
        iscompusEmail: true,
      });

      inputDOM.length && (inputDOM = inputDOM[0]);
      inputDOM && inputDOM.blur();
    } else {
      self.setState({
        iscompusEmail: false,
      });
    }
  }

  phoneCodeChange(event) {
    var self = this;
    self.setState({
      PhoneCode: event.target.value,
    });
  }
  //

  submitDisabled() {
    var self = this;
    const { registerType } = self.state;
    if (registerType === REGISTER_TYPE_PHONE) {
      if (!self.state.tcChecked) {
        return true;
      }

      return false;
    }

    if (!self.state.userEmail || !validator.isEmail(self.state.userEmail)) {
      return true;
    } else if (!APP_CONFIG.isHidePhoneLogic && !self.state.phoneNumber) {
      return true;
    } else if (!APP_CONFIG.isHidePhoneLogic && !self.state.country) {
      return true;
    } else if (!APP_CONFIG.isHidePhoneLogic && !self.state.PhoneCode) {
      return true;
    } else if (!self.state.password) {
      return true;
    } else if (!self.state.tcChecked) {
      return true;
    } else if (!self.state.notSingaporeChecked && APP_CONFIG.isNotSingapore) {
      return true;
    } else if (self.state.error) {
      return true;
    }

    return false;
  }

  onTCChange(val) {
    this.setState({
      tcChecked: val,
    });
  }

  onSCTCChange(val) {
    this.setState({
      notSingaporeChecked: val,
    });
  }

  onEmailInputBlur(event) {
    var _value = event.target.value;
    if (!_value) {
      return;
    }
    var self = this;
    if (!validator.isEmail(_value)) {
      self.setState({
        errorMsg: localeService.getTranslate("LOGIN42"),
      });
    } else {
      self.setState({
        errorMsg: "",
      });
    }
  }

  onPhoneBlur(event) {
    // var _value = event.target.value;
    // var self = this;
    // console.log('validator.isEmail',validator.isEmail(_value));
    // if(!validator.isEmail(_value)){
    //     self.setState({
    //         errorMsg : localeService.getTranslate('LOGIN42')
    //     })
    // }
  }

  strengthChange(strength) {
    var self = this;
    self.setState({
      passwordStrength: strength,
    });
  }
  onErrorChange(flag){
    this.setState({
      error: flag
    })
  }
  // isPasswordValue() {

  //   return !self.state.error;
  // }

  onUserEmailFocus() {
    dasService.report("REGISTER_EMAIL_FOCUS");
  }

  onPasswordFocus() {
    var self = this;
    self.setState({
      isShowRule: true,
    });
    dasService.report("REGISTER_PASSWORD_FOCUS");
  }

  countryListOpen() {
    var self = this;
    if (!self.state.isCountryOpen) {
      self.setState({
        isCountryOpen: true,
      });
      window.setTimeout(function () {
        window.addEventListener("click", self.countryListCloseHandler);
      });
    } else {
      self.countryListCloseHandler();
    }
  }

  countryListClose() {
    var self = this;
    self.setState({
      isCountryOpen: false,
    });
    window.removeEventListener("click", self.countryListCloseHandler);
  }

  getSwitchDisabledCopy() {
    var self = this;
    if (self.state.phoneCountSecond > 0) {
      return localeService.getTranslate("LOGIN43");
    }

    if (self.state.country !== "86") {
      return localeService.getTranslate("LOGIN44");
    }

    return "";
  }

  verifyPictureCodeChange(value) {
    this.setState({
      PictureCode: value,
      pictureCodeErrorMsg: "",
    });
  }
  changeVerifyPictureCode() {
    this.verifySid = uuid();
    this.forceUpdate();
  }

  //点击函数 出现验证码弹窗
  clickShowCodeModal() {
    var self = this;
    if (!self.state.userEmail || !validator.isEmail(self.state.userEmail)) {
      return self.setState({ errorMsg: localeService.getTranslate("LOGIN42") });
    } else if (!validator.isNumeric(self.state.phoneNumber)) {
      return self.setState({
        errorMsg: localeService.getTranslate("INVALID_MOBILE"),
      });
    }
    return self.setState({ showCodeModal: true, errorMsg: "" });
  }

  componentWillUnmount() {
    this.clearAllInterval();
  }

  goToCampusRegister = () => {
    const { iscompusEmail, userEmail } = this.state;
    if (iscompusEmail) {
      localStorage.setItem("PASS-USER-MAIL", userEmail);
    }
    browserHistory.push("/register/campus");
  };

  buildEmailRegister() {
    const self = this;
    const { lang } = this.state;
    let _verifyUrl = `${config.dws}/captcha?SID=${this.verifySid}`;
    let _countryList = [];
    _.each(this.state.currentCountryList, (item) => {
      _countryList.push(
        <NewSelect.Option
          key={item.CountryCode + Math.random()}
          value={item.PhonePrefix}
        >
          {lang === "EN" ? item.CountryName : item.CountryAlias} (
          {item.PhonePrefix})
        </NewSelect.Option>
      );
    });

    return (
      <Fragment>
        <div className="app-form-item">
          <Input
            ref={(ref) => {
              self.emailInput = ref;
            }}
            type="text"
            placeholder={APP_CONFIG.channelId === 124 ? localeService.getTranslate("LOGIN80") : localeService.getTranslate("LOGIN0")}
            onChange={this.userEmailChange.bind(this)}
            onFocus={this.onUserEmailFocus.bind(this)}
            value={this.state.userEmail}
            onBlur={(event) => {
              self.onEmailInputBlur(event);
            }}
            size="lg"
          />
        </div>
        <NewPassword
          onStrengthChange={self.strengthChange.bind(this)}
          onFocus={this.onPasswordFocus.bind(this)}
          needStrength={true}
          onErrorChange={this.onErrorChange.bind(this)}
          passwardPolicy={ 
            {
              RequireUppercaseCharacters: true,
              RequireLowercaseCharacters:true,
              RequireNumbers:false,
              RequireSymbols:true,
              MinimumPasswordLength: 6,
            }
          }
          onChange={this.passwordChange.bind(this)}
          placeholder={localeService.getTranslate("LOGIN17")}
        />
        {!APP_CONFIG.isHidePhoneLogic && (
          <div>
            <div className="register-cellphone app-form-item u-pos-rel">
              <Input
                onBlur={this.onPhoneBlur.bind(this)}
                value={this.state.phoneNumber}
                onChange={this.changePhoneNumber.bind(this)}
                ref="phoneNumber"
                size="lg"
                placeholder={localeService.getTranslate("LOGIN15")}
                onFocus={() => {
                  this.setState({ showCodeInput: true });
                }}
              />
              <div
                className="register-zone-number-wrapper"
                onClick={self.countryListOpen.bind(self)}
              >
                <NewSelect
                  className="uc-select"
                  defaultValue={this.state.country}
                  renderSelector={(c, v) => (
                    <div className="uc-select__selected-value">
                      {`+${this.state.country}`}
                      {v ? (
                        <span className="uc-select__arrow icon__up" />
                      ) : (
                        <span className="uc-select__arrow icon__down" />
                      )}
                    </div>
                  )}
                  onChange={this.selectCountry.bind(this)}
                  size="lg"
                  popoverProps={{
                    getPopupContainer: () => this._table,
                  }}
                  search={{
                    handleSearch,
                  }}
                >
                  {_countryList}
                </NewSelect>
              </div>
            </div>
            <div className="app-form-item">
              <Input
                type="text"
                className={isMobile() ? "" : "u-dib u-vm u-mr10"}
                size="lg"
                autoComplete="off"
                placeholder={localeService.getTranslate("LOGIN16")}
                // prefix={<Icon type="safe2"></Icon>}
                onChange={this.phoneCodeChange.bind(this)}
                suffix={
                  <div className="phone-code-icon-wrapper u-dib u-vm">
                    <div className="phone-code-counter">
                      {this.buildCodeContent()}
                    </div>
                  </div>
                }
              />
            </div>
          </div>
        )}
        <div id="captcha" />
        <CodeModal
          visible={this.state.showCodeModal}
          _verifyUrl={_verifyUrl}
          phoneNum={this.state.phoneNumber}
          inputValue={this.state.PictureCode}
          pictureCodeErrorMsg={this.state.pictureCodeErrorMsg}
          verifyPictureCodeChange={(value) =>
            this.verifyPictureCodeChange(value)
          }
          changeVerifyPictureCode={() => this.changeVerifyPictureCode()}
          onCancel={() => {
            this.setState({
              showCodeModal: false,
              pictureCodeErrorMsg: "",
              PictureCode: "",
            });
          }}
          sendVerifyCode={() => this.sendVerifyCode()}
        />
      </Fragment>
    )
  }

  updatePhoneState = (type, value) => {
    if (type === "country") {
      this.setState({ phoneTabCountry: value });
    }
    if (type === "phoneNumber") {
      this.setState({ phoneTabPhoneNumber: value });
    }
    if (type === "PhoneCode") {
      this.setState({ phoneTabPhoneCode: value });
    }
    if (type === "errorMsg") {
      this.setState({ errorMsg: value });
    }
  };

  buildPhoneRegister() {
    const { phoneTabPhoneNumber, phoneTabCountry, phoneTabPhoneCode } = this.state;

    return (
      <div className="app-form-item" style={{ marginTop: 16 }}>
        <div className="remark-text-color font-14" style={{ lineHeight: '22px' }}>
          {localeService.getTranslate("REGISTER_PHONE_NOTICE")}
        </div>
        <PhoneInput
          phoneNumber={phoneTabPhoneNumber}
          country={phoneTabCountry}
          PhoneCode={phoneTabPhoneCode}
          updatePhoneState={this.updatePhoneState}
        />
      </div>
    )
  }

  handleRegisterTypeChange = (key) => {
    this.setState({
      registerType: key
    });
  }

  render() {
    const self = this;
    const { registerType } = self.state;
    setTitle("LOGIN55");
    const commitDisabled = this.submitDisabled();
    return (
      <div
        className="register-form-wrapper u-register-width-large"
        style={{ paddingTop: 0 }}
      >
        <div style={{ position: "relative" }}>
          {this.state.errorMsg ? (
            <Notice
              className="register-notice"
              styleType="error"
              message={this.state.errorMsg}
            />
          ) : (
            false
          )}
          <div
            className="selectlist-drawdown"
            ref={(tableDiv) => (this._table = tableDiv)}
          />

          {self.state.iscompusEmail && !isMobile() && (
            <CompusTipContainer isMobile={isMobile()}>
              <div className="uc-compus-triangle"></div>
              <div className="uc-compus-wrapper">
                {localeService.getTranslate("CAMPUS22")}
              </div>
            </CompusTipContainer>
          )}
          {self.state.iscompusEmail && isMobile() && (
            <CompusTipMobileContainer isMobile={isMobile()}>
              <div className="uc-compus-triangle"></div>
              <div className="uc-compus-wrapper">
                {localeService.getTranslate("CAMPUS23")}
              </div>
            </CompusTipMobileContainer>
          )}

          <Form style={{ position: "relative" }}>
            {(APP_CONFIG.isOAuthByGoogle || APP_CONFIG.isOAuthByGithub) ? (
              <SocialRegisterTitle>
                <div
                  className="social-title-right campus-register-btn"
                  onClick={() =>
                    this.props.changeActiveState("loginTab")
                  }
                >
                  {localeService.getTranslate("CAMPUS24")} &gt;
                </div>
              </SocialRegisterTitle>
            ) : (
              <SocialRegisterTitle>
                {!APP_CONFIG.isHideCampusRegister && (
                  <div
                    className="social-title-right campus-register-btn"
                    onClick={this.goToCampusRegister}
                  >
                    <Icon
                      className="primary-color icon-phone-gap u-mr6"
                      type="id-card"
                      prefix="icon-uc-user__"
                    />
                    {localeService.getTranslate("CAMPUS09")}
                    {!isMobile() && <Icon type="right" prefix="icon__" />}
                  </div>
                )}
              </SocialRegisterTitle>
            )}

            {
              isMobile() ? (
                <RegisterTabWrapper>
                  <div className="uc-fe-tabs-tab uc-fe-tabs-tab-active">{localeService.getTranslate(REGISTER_TYPES_MAP[registerType])}</div>
                  {
                    (REGISTER_TYPES.filter((item) => item !== registerType).length > 0) && localeService.getTranslate("REGISTER_CHANGE")
                  }
                  <Fragment>
                    {
                      REGISTER_TYPES.filter((item) => item !== registerType).map((item) => {
                        return (
                          <span
                            key={item}
                            className="u-blue"
                            onClick={() => this.handleRegisterTypeChange(item)}
                          >
                            {localeService.getTranslate(REGISTER_TYPES_MAP[item])}
                          </span>
                        )
                      })
                    }
                  </Fragment>
                  {
                    registerType === REGISTER_TYPE_EMAIL && this.buildEmailRegister()
                  }
                  {
                    registerType === REGISTER_TYPE_PHONE && this.buildPhoneRegister()
                  }
                </RegisterTabWrapper>
              ) : (
                <RegisterTabWrapper>
                  <Tabs styleType="ink" size="lg" activeKey={registerType} onChange={this.handleRegisterTypeChange}>
                    {
                      REGISTER_TYPES.map((item) => {
                        return (
                          <Tabs.Pane key={item} tab={<span>{localeService.getTranslate(REGISTER_TYPES_MAP[item])}</span>}>
                            {
                              item === REGISTER_TYPE_EMAIL && this.buildEmailRegister()
                            }
                            {
                              item === REGISTER_TYPE_PHONE && this.buildPhoneRegister()
                            }
                          </Tabs.Pane>
                        )
                      })
                    }
                  </Tabs>
                </RegisterTabWrapper>
              )
            }
          </Form>
          {/* 勾选协议 */}
          <TcCheckBox
            checked={this.state.tcChecked}
            isShowNotSingaporeCheck={true}
            notSingaporeChecked={this.state.notSingaporeChecked}
            location={this.props.location}
            notSingaporeChange={this.onSCTCChange.bind(this)}
            onChange={this.onTCChange.bind(this)}
          />
          <LoginButtonContainer>
            <Button
              size="lg"
              styleType="primary"
              className={`${isMobile() ? "" : "u-mt12"} login-btn`}
              onClick={commitDisabled ? () => { } : this.registerPreHandle.bind(this)}
            >
              {localeService.getTranslate("LOGIN18")}
            </Button>
            {commitDisabled && <div className="pass-login-diasbled"></div>}
          </LoginButtonContainer>
          {(!APP_CONFIG.isOAuthByGoogle || !APP_CONFIG.isOAuthByGithub) && (
            <AccoutLoginContainer
              onClick={() => {
                this.props.changeActiveState("loginTab");
              }}
            >
              <span className="u-vm u-blue">
                {localeService.getTranslate("CAMPUS24")}
                <Icon type="right" prefix="icon__" />
              </span>
            </AccoutLoginContainer>
          )}
          {APP_CONFIG.isOAuthByGoogle && (
            <OAuthBtn
              type="Register"
              bindChange={() => {
                this.RegisterByOAuth = 'Google';
                this.bindVerify && this.bindVerify();
                dasService.report("REGISTER_GOOGLE_CLICK");
              }}
            />
          )}
          {APP_CONFIG.isOAuthByGithub && (
            <OAuthGithub
              type="Register"
              bindChange={() => {
                this.RegisterByOAuth = 'GitHub';
                this.bindVerify && this.bindVerify();
                dasService.report("REGISTER_GITHUB_CLICK");
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// src/pc/components/RegisterForm.jsx